import React, { Component } from 'react';
// import { HiOutlineMail } from "react-icons/hi";
// import { FiLock } from "react-icons/fi";
import { BsPerson, BsPersonFill, BsFillEnvelopeFill, BsLockFill } from "react-icons/bs";
import firebase from "firebase/app";
import "firebase/auth";

import Ripples from 'react-ripples'
import './Login.css';
// import withFirebaseAuth from 'react-with-firebase-auth'
// import firebase from 'firebase/app';
import 'firebase/auth';
// import { firebaseConfig } from './FirebaseConfig';
import history from "../history";
import Route from './Route';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

// const firebaseApp = firebase.initializeApp(firebaseConfig);

class Login extends Component {

    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: ''
        };
        this.onInputChange = this.onInputChange.bind(this);
    }
    signInWithEmailPassword = () => {
        // console.log('oh sh')
        // history.push('/dashboard');
        // window.location.reload(false);
        firebase
        .auth()
        .signInWithEmailAndPassword(this.state.email, this.state.password)
        .then((userCredential) => {
            console.log('userCredential',userCredential)
          toast("User Logged in Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: true,
          });
          // console.log(auth().currentUser+ 'shh');
          history.push('/dashboard');             
        window.location.reload(false);
          // Signed in
        //   var user = userCredential.user;
  
        //   this.addUser(user.uid);
  
          // ...
        })
        .catch((error) => {
            console.log(error)
        //   var errorCode = error.code;
        //   var errorMessage = error.message;
          // alert(error)
          toast("" + error, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: true,
          });
        });



    }

    onInputChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

   

    render() {
        return (
            <div className={'loginMainContainer'}>
                <div className={'loginFormBelowDiv'}>
                    <div className={"loginForm"}>
                        <div className={"loginHeading"}>Login</div>

                        <div className={'loginContainer'}>
                            <BsFillEnvelopeFill style={{ height: 27, width: 25, color: '#21618C' }} />                            
                            <input className={'loginInput'}
                                type={'text'}
                                placeholder={'Email'}
                                name={'email'}
                                value={this.state.email}
                                onChange={this.onInputChange}
                            />
                        </div>

                        <div className={'loginContainer'}>
                            <BsLockFill style={{ height: 27, width: 29, color: '#21618C' }} />                            
                            <input className={'loginInput'}
                                type={'password'}
                                placeholder={'Password'}
                                name={'password'}
                                value={this.state.password}
                                onChange={this.onInputChange}
                            />
                        </div>


                           <Ripples color="#DCDCDC" during={1200} className={'loginButtonRipples'}>
                           <button className={'loginButton'}
                              onClick={this.signInWithEmailPassword}
                          // onClick={() => { this.signupValidation, this.reset() }}
                          >
                              LOGIN
                              </button>
                      </Ripples>
                    </div>
                    <div className={'loginLogo'}></div>
                </div>
            </div>   
        );
    }
}

export default Login